import { DatalayerLinkTypes } from '@/datalayer/App.datalayer.constants';
import { BlueArrowIcon } from '@/features/shared/Icons';
import { MuiButton, MuiTypography } from '@/features/shared/material-ui';
import { useNavigationHistory } from '@/hooks/useNavigationHistory';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { ComponentProps, useCallback } from 'react';
import useBackButtonNavigationStyles from './BackButtonNavigation.styles';

export interface BackButtonNavigationProps {
  buttonLabel: string;
  theme?: Theme;
}

const BackButtonNavigation = ({
  buttonLabel,
  theme,
  ...restProps
}: BackButtonNavigationProps & ComponentProps<typeof MuiButton>) => {
  const classes = useBackButtonNavigationStyles();

  const { prevLocation, goBack } = useNavigationHistory();

  const handleGoBackClick = useCallback(() => {
    goBack();
  }, [goBack]);

  return (
    <MuiButton
      className={clsx(classes.root, `${theme}-theme`, restProps.className)}
      variant="text"
      startIcon={<BlueArrowIcon direction="left" />}
      onClick={handleGoBackClick}
      data-datalayer-cta-type="internal_link"
      data-datalayer-link-type={DatalayerLinkTypes.CTA}
      data-datalayer-link
      data-datalayer-link-href={prevLocation}
      {...restProps}
    >
      <MuiTypography component="span" className={clsx(classes.buttonLabel, `${theme}-theme`)}>
        {buttonLabel}
      </MuiTypography>
    </MuiButton>
  );
};

export default BackButtonNavigation;
